import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../customcss.css'
import { projectArch } from "../data";
import '../customcss.css'
import { CubeIcon } from "@heroicons/react/solid";
import { Link } from "react-router-dom";



export default function ProjectArch() {
  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
    return (
        <section id="product" className="slide-container slideshow 	">
          <div className="slide-container slideshow">
          <div className="text-center mb-20">
          <CubeIcon className="w-10 inline-block mb-4" />
          <Link to = "/Architecture">
          <h1 className="sm:text-4xl text-3xl font-medium title-font text-white mb-2">
            Architectural Design 
          </h1>
          </Link>
        </div>
                <Slider {...settings}>
                    {projectArch.map((projectArch)=> (
                    <div className="card">
                      <h1 className="center font-bold">{projectArch.title}</h1>
                        <a href ="">
                        <img src={projectArch.src}/>
                        <p className="center">{projectArch.description}</p>
                        </a>
                    </div>
                    ))}
                </Slider>
          </div>
      </section>
    )
}


      

// import React from "react";
// import HorizontalScroll from 'react-horizontal-scrolling'
// import 'react-slideshow-image/dist/styles.css'
// import { projectArch } from "../data";
// import "../customcss.css";


// export default function ProjectArch() {
//     return (
//         <HorizontalScroll>
//             <div className=" mx-auto  place-content-center flex">
//             {projectArch.map((projectArch, idx) => (        
//             <div className="">
//            <img
//             className=" rounded w-96 h-64 object-cover"
//             src={projectArch.src}
//             alt={projectArch.alt}
//             key={idx} />
//             </div>
//             ))};
//             </div>
//         </HorizontalScroll>
//     );
// }